<template>
  <div class="link-selector">
    <v-select
      class="select-primary"
      style="width: 100%"
      :options="displayLinks"
      label="displayTitle"
      :reduce="(option) => option.id"
      v-model="id"
      @input="onChange"
      placeholder="링크선택"
    />
  </div>
</template>
<script>
import Endpoints from "@/common/Endpoints";
import _ from "lodash";

export default {
  components: {},
  name: "LinkSelect",
  async created() {
    await this.getData();
  },
  data() {
    return {
      links: [],
      id: null,
    };
  },
  props: {
    linkModel: {
      type: String,
      required: true,
    },
    platformAware: {
      type: Boolean,
      default: false,
    },
    allowedLinkType: {
      type: String,
      default: null,
    },
    allowCustom: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    displayLinks() {
      const links = this.links.filter((link) => !this.allowedLinkType || !link.id || (link.linkType || "INTERNAL") === this.allowedLinkType);
      const options = this.allowCustom ? [...links, { id: "custom", title: "수동 입력", linkType: this.allowedLinkType || "INTERNAL", isCustom: true }] : links;

      return options.map((link) => ({
        ...link,
        displayTitle: this.platformAware && link.id && !link.isCustom ? `${link.title} · ${link.webLink ? "앱/웹" : "앱 전용"}` : link.title,
      }));
    },
  },
  watch: {
    allowedLinkType() {
      this.id = null;
    },
  },
  methods: {
    async getData() {
      const res = await this.$axios.get("/common/deeplinks");
      this.links = [{ id: null, title: "없음" }, ...res.data.data];
    },
    onChange() {
      const link = _.find(this.displayLinks, { id: this.id });
      if (link?.isCustom) {
        this.$emit("linkChangeEvent", { custom: true, linkModel: this.linkModel });
        return;
      }
      let value = "";
      if (link) {
        value = `${Endpoints.blipSchema}${link.link}`;
      }
      if (link?.required) {
        const params = link.required.split(",");
        value = `${value}?${params.map((p) => `${p}=${link.linkType === "EXTERNAL" && p === "url" ? "" : "?"}`).join("&")}`;
      }
      this.$emit("linkChangeEvent", {
        value,
        webValue: this.getWebValue(link),
        linkType: link?.linkType || "INTERNAL",
        linkModel: this.linkModel,
      });
    },
    getWebValue(link) {
      if (!link?.webLink) {
        return null;
      }

      const value = /^https?:\/\//i.test(link.webLink) ? link.webLink : `${Endpoints.homepageUrl.replace(/\/$/, "")}/${link.webLink.replace(/^\//, "")}`;

      if (!link.required) {
        return value;
      }

      const params = link.required.split(",");
      const separator = value.includes("?") ? "&" : "?";
      return `${value}${separator}${params.map((p) => `${p}=?`).join("&")}`;
    },
  },
};
</script>
